import React from 'react';

type DownloadIconProps = {
  width?: number;
  height?: number;
};
function DownloadIcon({ width = 20, height = 20 }: DownloadIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_19520_36027" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_19520_36027)">
        <path
          d="M4.9987 16.6663C4.54036 16.6663 4.14814 16.5033 3.82203 16.1772C3.49536 15.8505 3.33203 15.458 3.33203 14.9997V12.4997H4.9987V14.9997H14.9987V12.4997H16.6654V14.9997C16.6654 15.458 16.5023 15.8505 16.1762 16.1772C15.8495 16.5033 15.457 16.6663 14.9987 16.6663H4.9987ZM9.9987 13.333L5.83203 9.16634L6.9987 7.95801L9.16536 10.1247V3.33301H10.832V10.1247L12.9987 7.95801L14.1654 9.16634L9.9987 13.333Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
}

export default DownloadIcon;
